import { request } from "../../../services/api"
import type { BaseApiResponse, BasePagination } from "../../../types/api.ts"
import type {
  ProjectDocument,
  ProjectDocumentFilterOptions,
  ProjectDocumentMoveData,
  ProjectDocumentUploadData,
  ProjectDocumentsParams
} from "../types/project-documents.types.ts"

// Documents are `core.ProjectAttachment` rows — the paperwork store, separate
// from the generic attachments the album surfaces read.
const BASE_URL = `/project-management/project-attachments`

const PATHS = {
  getDocuments: `${BASE_URL}/`,
  getFilterOptions: `${BASE_URL}/filter_options/`,
  createDocument: `${BASE_URL}/`,
  moveDocument: (id: string) => `${BASE_URL}/${id}/`,
  deleteDocument: (id: string) => `${BASE_URL}/${id}/`
}

// GET /project-management/project-attachments/
export const getProjectDocuments = async (params: ProjectDocumentsParams) => {
  return request.api.get<
    BasePagination<ProjectDocument>,
    BaseApiResponse<unknown>
  >(PATHS.getDocuments, params)
}

// GET /project-management/project-attachments/filter_options/
// Answers with a bare object, not the standard details/data envelope.
export const getProjectDocumentFilterOptions = async () => {
  return request.api.get<
    ProjectDocumentFilterOptions,
    BaseApiResponse<unknown>
  >(PATHS.getFilterOptions)
}

// POST /project-management/project-attachments/
export const createProjectDocument = async (
  data: ProjectDocumentUploadData
) => {
  return request.api.post<
    BaseApiResponse<ProjectDocument>,
    BaseApiResponse<unknown>
  >(PATHS.createDocument, data, {
    headers: { "Content-Type": "multipart/form-data" }
  })
}

// PATCH /project-management/project-attachments/:id/ — folder placement only
export const moveProjectDocument = async (
  id: string,
  data: ProjectDocumentMoveData
) => {
  return request.api.patch<
    BaseApiResponse<ProjectDocument>,
    BaseApiResponse<unknown>
  >(PATHS.moveDocument(id), data)
}

// DELETE /project-management/project-attachments/:id/
export const deleteProjectDocument = async (id: string) => {
  return request.api.delete<BaseApiResponse<unknown>, BaseApiResponse<unknown>>(
    PATHS.deleteDocument(id)
  )
}
